export enum IconType {
  Button = 'button'
}
